import React from 'react'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import "./auth/AuthPages.css"
import "./NotFound.css"

function NotFound() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  let isConnected = false;
  try {
    const storedUser = localStorage.getItem('user');
    isConnected = !!(storedUser && storedUser !== 'null');
  } catch (error) {
    isConnected = false;
  }

  return (
    <main className="auth-page not-found-page">
      <div className="not-found-card">
        <span className="not-found-code" aria-hidden="true">404</span>
        <h1>{t('page_not_found', 'Page introuvable')}</h1>
        <p>
          {isConnected
            ? t('page_not_found_connected', "Cette page n'existe pas ou a été déplacée. Retournez à votre tableau de bord.")
            : t('page_not_found_guest', "Cette page n'existe pas ou a été déplacée. Retournez à la page de connexion.")}
        </p>
        <button type="button" className="not-found-button" onClick={() => navigate('/')}>
          <i className="fas fa-arrow-left" aria-hidden="true" />
          <span>{isConnected ? t('back_to_dashboard', 'Retour au tableau de bord') : t('back_to_login', 'Retour à la connexion')}</span>
        </button>
      </div>
    </main>
  )
}

export default NotFound
